import React from 'react';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import EnrollmentCell from './enrollment-cell';
import LifeEventForm from './life-event-form';

const LifeEvent = ({submitting, lastColumn}) => {
    return ( 
        <EnrollmentCell title="Qualifying Life Event" buttonName="Update based on life event" submitting={submitting} enrollmentType={EnrollmentType.LifeEvent} lastColumn={lastColumn} >
            <p className="text-sm">
                <strong>You must make this change within 30-days</strong> of the effective date of the Qualifying Life Event; otherwise, you will need to wait until the next Open Enrollment window.
            </p>
            <p className="text-sm mt-4">
                This option is for those who experience a Qualifying Life Event and need to immediately update benefits, dependents, or beneficiaries based on that Qualifying Life Event. 
            </p>
            <p className="text-sm mt-4">
                These changes are meant to be for immediate change, not for Open Enrollment purposes. 
            </p>
            <LifeEventForm />
      </EnrollmentCell>
 );
}
 
export default LifeEvent;